import { ISitePagesDTO } from 'API/Feedback/feedback';
import {
  EXISTING_FORM_IMPROVEMENT_AREAS,
  HELPFULNESS,
  HELPFULNESS_RATING,
  NEGATIVE_FEEDBACK_REASONS,
  NEW_FORM_IMPROVEMENT_AREAS,
  NEW_PAGE_THOUGHTS,
  REASONS,
  THOUGHTS,
} from 'Enum/Feedback';

const getHelpfulnessRating = (helpfulnessValue: HELPFULNESS | '') => {
  switch (helpfulnessValue) {
    case HELPFULNESS.Helped:
      return HELPFULNESS_RATING.Helped;
    case HELPFULNESS.PartiallyHelped:
      return HELPFULNESS_RATING.PartiallyHelped;
    case HELPFULNESS.DidNotHelp:
      return HELPFULNESS_RATING.DidNotHelp;
    default:
      return '';
  }
};

const getImprovementArea = (
  thoughtsValue: THOUGHTS | NEW_PAGE_THOUGHTS | '',
  isNew?: boolean
) => {
  switch (thoughtsValue) {
    case THOUGHTS.improvement:
      return isNew
        ? NEW_FORM_IMPROVEMENT_AREAS.ImprovementRequired
        : EXISTING_FORM_IMPROVEMENT_AREAS.ImprovementRequired;
    case THOUGHTS.problem:
      return isNew
        ? NEW_FORM_IMPROVEMENT_AREAS.TechnicalProblem
        : EXISTING_FORM_IMPROVEMENT_AREAS.TechnicalProblem;
    case THOUGHTS.like:
      return EXISTING_FORM_IMPROVEMENT_AREAS.Liked;
    case NEW_PAGE_THOUGHTS.other:
      return NEW_FORM_IMPROVEMENT_AREAS.Other;
    default:
      return '';
  }
};

const getReason = (reasonValue: REASONS | '') => {
  switch (reasonValue) {
    case REASONS.comfort:
      return NEGATIVE_FEEDBACK_REASONS.NotComfortable;
    case REASONS.clarity:
      return NEGATIVE_FEEDBACK_REASONS.Unclear;
    case REASONS.other:
      return NEGATIVE_FEEDBACK_REASONS.Other;
    default:
      return '';
  }
};

interface IGetFormData {
  currentPage: ISitePagesDTO | null;
  helpfulnessValue: HELPFULNESS | '';
  thoughtsValue: THOUGHTS | NEW_PAGE_THOUGHTS | '';
  reasonValue: REASONS | '';
  noteValue: string;
  file: File | null;
  recordedBlob: Blob | null;
  deviceId?: number;
  browserId?: number;
  deviceDetails?: string;
}

export const getFormData = ({
  currentPage,
  helpfulnessValue,
  thoughtsValue,
  reasonValue,
  noteValue,
  file,
  recordedBlob,
  deviceId,
  browserId,
  deviceDetails,
}: IGetFormData) => {
  const formData = new FormData();
  formData.append('pageNumber', (currentPage?.id || 1).toString());
  if (currentPage?.isNew)
    formData.append(
      'helpfulnessRating',
      getHelpfulnessRating(helpfulnessValue).toString()
    );
  if (helpfulnessValue !== HELPFULNESS.Helped)
    formData.append(
      'improvementArea',
      getImprovementArea(thoughtsValue).toString()
    );
  formData.append('negativeFeedbackReason', getReason(reasonValue).toString());
  switch (thoughtsValue) {
    case THOUGHTS.improvement:
      formData.append('detailedImprovement', noteValue);
      break;
    case THOUGHTS.problem:
      formData.append('detailedTechnicalProblem', noteValue);
      break;
    case THOUGHTS.like:
      formData.append('detailedPositiveFeedback', noteValue);
      break;
    case NEW_PAGE_THOUGHTS.other:
      formData.append('detailedImprovement', noteValue);
      break;
    default:
      break;
  }
  if (deviceId) formData.append('deviceId', deviceId.toString());
  if (browserId) formData.append('browserId', browserId.toString());
  if (deviceDetails) formData.append('deviceDetails', deviceDetails);
  if (file) formData.append('attachmentData', file);
  if (recordedBlob) formData.append('RecordingAttachmentData', recordedBlob);

  return formData;
};
